/* eslint-disable no-nested-ternary */
import styled from "styled-components";
import color from "../../../../constants/color";

// ── Board ──────────────────────────────────────────────────────────────────────
export const BoardContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  align-items: flex-start;
  height: calc(100vh - 290px);
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${color.Mediumgrey};
    border-radius: 4px;
  }
`;

// ── Column ─────────────────────────────────────────────────────────────────────
export const Column = styled.div<{
  isDragOver?: boolean;
  isValidTarget?: boolean;
}>`
  width: calc(25vw - 24px);
  min-width: 270px;
  max-width: 320px;
  background: ${({ isDragOver, isValidTarget }) =>
    isDragOver && isValidTarget
      ? "#e0e7ff"
      : isDragOver && !isValidTarget
      ? "#FFF0F0"
      : "#f1f2f4"};
  border-radius: 16px;
  border: 2px solid
    ${({ isDragOver, isValidTarget }) =>
      isDragOver && isValidTarget
        ? "#2D5BFF"
        : isDragOver && !isValidTarget
        ? "#FF4D4D"
        : "transparent"};
  transition: border-color 0.15s ease, background 0.15s ease;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  padding: 10px;
`;

// Header do kanban
export const ColumnHeader = styled.div`
  background: #fff;
  border-left: 4px solid #2d5bff;
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

export const ColumnTitle = styled.span`
  font-family: Inter;
  font-size: 11px;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 170px;
`;

export const ColumnCount = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 700;
  color: #666;
  background: #f0f0f0;
  border-radius: 20px;
  padding: 1px 8px;
  flex-shrink: 0;
`;

export const ColumnCards = styled.div<{
  isDragOver?: boolean;
  isValidTarget?: boolean;
}>`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${({ isDragOver, isValidTarget }) =>
    isDragOver && isValidTarget ? "rgba(45, 91, 255, 0.04)" : "transparent"};
  transition: background 0.15s ease;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 4px;
  }
`;

// ── Card ───────────────────────────────────────────────────────────────────────
export const Card = styled.div<{ isDragging?: boolean }>`
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  transition: box-shadow 0.15s ease, opacity 0.15s ease, transform 0.1s ease;
  opacity: ${({ isDragging }) => (isDragging ? 0.4 : 1)};
  box-shadow: ${({ isDragging }) =>
    isDragging ? "0 8px 24px rgba(0,0,0,0.18)" : "0 1px 4px rgba(0,0,0,0.05)"};

  &:hover {
    box-shadow: 0 4px 16px rgba(45, 91, 255, 0.12);
    border-color: #c8d4ff;
  }
  &:active {
    cursor: grabbing;
  }
`;

// Farol: faixa colorida no topo do card
export const CardFarol = styled.div<{ bg: string; textColor: string }>`
  background: ${({ bg }) => bg};
  color: ${({ textColor }) => textColor};
  font-family: Inter;
  font-size: 11px;
  font-weight: 500;
  padding: 5px 12px;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;

  > span:first-of-type {
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
`;

// Corpo do card
export const CardBody = styled.div`
  padding: 12px 12px 10px;
`;

// Nome + código + menu (3 pontos)
export const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
`;

export const CardLeadAvatar = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
`;

export const CardLeadAvatarFallback = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eef2ff;
  color: #2d5bff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardName = styled.p`
  font-family: Inter;
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;

export const CardCodigo = styled.span`
  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  color: #2d5bff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eef2ff;
  border: 1px solid #d6defb;
  padding: 2px 8px;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #2d5bff;
    color: #fff;
  }
`;

export const CardCreatedAt = styled.span`
  font-family: Inter;
  font-size: 11px;
  font-weight: 500;
  color: #2d5bff;
  white-space: nowrap;
`;

export const CardFarolDate = styled.span`
  margin-left: auto;
  font-size: 10px;
  font-weight: 500;
  opacity: 0.85;
  white-space: nowrap;
  flex-shrink: 0;
`;

// Agrupa ícone whatsapp + texto mascarado + botão copiar
export const CardPhoneGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1;
  min-width: 0;
  overflow: visible;
`;

export const CardWhatsAppIconWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardWhatsAppUnreadBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #25d366;
  color: #ffffff;
  font-size: 9px;
  line-height: 16px;
  text-align: center;
  padding: 0 3px;
  font-weight: 700;
  box-shadow: 0 0 0 2px #fff;
`;

// Botão copiar
export const CopyBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 3px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: #bbb;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;
  &:hover {
    background: #f0f0f0;
    color: #2d5bff;
  }
`;

// Linha com telefone + etiqueta
export const CardPhoneRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
`;

export const CardPhoneLink = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: inherit;
  flex: 1;
  min-width: 0;
  overflow: visible;
  border-radius: 6px;
  padding: 2px 0;
  transition: background 0.12s;
  &:hover {
    background: #f4f6ff;
  }
`;

export const CardPhoneText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
`;

// Linha email + botão Atualizar Lead
export const CardEmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 6px;
  overflow: hidden;
  min-width: 0;
  justify-content: space-between;
`;

// Agrupa ícone email + texto + botão copiar (lado esquerdo do CardEmailRow)
export const CardEmailGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  min-width: 0;
  flex: 1;
`;

export const CardEmailLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  text-decoration: none;
  color: inherit;
  overflow: hidden;
  flex: 1;
  min-width: 0;
`;

export const CardEmailText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
`;

// Linha clicável (empreendimento / produto / etapa)
export const CardClickableRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
  overflow: hidden;
  border-radius: 6px;
  padding: 3px 4px;
  cursor: pointer;
  transition: background 0.12s;
  &:hover {
    background: #f0f4ff;
  }
  &:hover span {
    color: #2d5bff;
  }
`;

export const CardClickableText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  transition: color 0.12s;
`;

// Empreendimento / Produto (mantido para compatibilidade)
export const CardEmp = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
  overflow: hidden;
`;

export const CardEmpText = styled.span`
  font-family: Inter;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;

// Texto placeholder quando não há dado
export const CardPhoneNoData = styled.span`
  font-family: Inter;
  font-size: 12px;
  color: #bbb;
  flex: 1;
`;

export const CardNoData = styled.span`
  font-family: Inter;
  font-size: 12px;
  color: #bbb;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Linha extra (não mais usada, mantida por compatibilidade)
export const CardUpdateBtnRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
`;

// Sub-etapa pill (badge azul) — clicável
export const CardSubEtapa = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: Inter;
  font-size: 11px;
  font-weight: 500;
  color: #2d5bff;
  background: #eef2ff;
  border-radius: 20px;
  padding: 3px 10px 3px 7px;
  margin-bottom: 6px;
  max-width: 100%;
  overflow: hidden;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: #dde4ff;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// Sub-etapa vazia
export const CardSubEtapaEmpty = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: Inter;
  font-size: 11px;
  color: #ccc;
  border-radius: 20px;
  padding: 3px 10px 3px 7px;
  margin-bottom: 6px;

  span {
    white-space: nowrap;
  }
`;

// Etiqueta clicável na linha do telefone
export const CardEtiqueta = styled.span<{ cor?: string }>`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  flex-shrink: 0;
  background: ${({ cor }) => cor || "#E0E0E0"};
  color: #fff;
  cursor: pointer;
  transition: opacity 0.15s, box-shadow 0.15s;
  &:hover {
    opacity: 0.85;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
`;

// Badge "sem etiqueta" (quando não há — clicável para adicionar)
export const CardEtiquetaEmpty = styled.span`
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  color: #aaa;
  border: 1px dashed #ccc;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
  &:hover {
    border-color: #2d5bff;
    color: #2d5bff;
    background: #f0f4ff;
  }
`;

// Divider
export const CardDivider = styled.div`
  height: 1px;
  background: #f0f0f0;
  margin: 6px 0;
`;

// Bottom row: badges + temperatura
export const CardBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 2px;
`;

export const CardBottomLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  overflow: hidden;
`;

// "Já é cliente" / "Compart." badge
export const CardBadge = styled.span`
  font-family: Inter;
  font-size: 10px;
  color: #666;
  background: #f4f6f8;
  border-radius: 20px;
  padding: 2px 7px 2px 5px;
  display: flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  flex-shrink: 0;
`;

// Temperatura pill
export const CardTemperatura = styled.span<{ temp?: string }>`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px 3px 6px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ temp }) => {
    const t = (temp || "").toLowerCase();
    if (t === "quente") return "#FFF0F0";
    if (t === "morno") return "#FFF4E5";
    if (t === "frio") return "#EEF6FF";
    return "#F4F6F8";
  }};
  color: ${({ temp }) => {
    const t = (temp || "").toLowerCase();
    if (t === "quente") return "#D93025";
    if (t === "morno") return "#C96A00";
    if (t === "frio") return "#1565C0";
    return "#666";
  }};
`;

// Corretor responsável + Equipe (gestores)
export const CardCorretorEquipeRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 4px;
`;

export const CardCorretorEquipeItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const CardCorretorEquipeLabel = styled.span`
  font-family: Inter;
  font-size: 10px;
  color: #888;
  font-weight: 400;
  margin-bottom: 2px;
`;

export const CardCorretorEquipeValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  font-family: Inter;
  font-size: 11px;
  font-weight: 500;
  color: #333;
`;

// Rodapé compartilhado — "Compartilhado por: foto + nome"
export const CardSharedBy = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #f0f0f0;
  font-family: Inter;
  font-size: 10px;
  color: #666;
  min-width: 0;
`;

export const CardSharedAvatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #e0e0e0;
`;

export const CardSharedAvatarFallback = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #dde4ff;
  color: #2d5bff;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardSharedName = styled.span`
  font-weight: 500;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

// Menu 3 pontos
export const CardMenuBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 3px 5px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  color: #bbb;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  &:hover {
    background: #f0f0f0;
    color: #444;
  }
`;

// Botão "Atualizar Lead"
export const CardUpdateBtn = styled.button`
  background: #2d5bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 3px 9px;
  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover {
    background: #1a43e0;
  }
`;

// ── Drop Placeholder ───────────────────────────────────────────────────────────
export const DropPlaceholder = styled.div`
  border: 2px dashed #2d5bff;
  border-radius: 12px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2d5bff;
  font-family: Inter;
  font-size: 12px;
  background: rgba(45, 91, 255, 0.04);
  flex-shrink: 0;
`;

export const EmptyColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  color: #bbb;
  font-family: Inter;
  font-size: 12px;
  min-height: 80px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
`;
